import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link, withRouter } from 'react-router-dom';

import { AppTheme } from '../styles/AppTheme';
import { CommonStyles } from '../styles/Styles';
import { DrawerMenu } from '../common/components/DrawerMenu';
import Icon from '@material-ui/core/Icon';
import { AppConfig } from '../AppConfig';
import { Controller } from '../common/Controller';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { Helper } from '../common/helpers/Helper';

export class MainHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drawerIsOpen: false,
      //sections: []
    }
  }

  componentDidMount() {
    //this.fetchItems()
  }

  toggleDrawer = (open) => () => {
    this.setState({ drawerIsOpen: open });
  };

  handleClick = () => {
    this.setState(prevState => ({
      drawerIsOpen: !prevState.drawerIsOpen
    }));
  }

  /*fetchItems() {
    ApiHelper.call(
      {
        method: 'GET',
        endPoint: ApiHelper.makeUrlPath(['/miscs/quiz-progress'],
          {
            quizId: AppConfig.quizId
          }
        )
      },
      function (err, results) {
        if (err) {
          this.setState({
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }

        let surveySections = []
        if (results.sections) {
          surveySections = results.sections.sort(function (a, b) { return (Number(a.order) - Number(b.order)) })
        }
        this.setState({
          sections: surveySections,
          fetchState: ApiHelper.State.READY
        })
      }.bind(this))
  }*/

  logOut = () => {
    const appUser = Controller.get().userMgr().getAppUser();
    if(appUser && appUser.state !== 'READY') {
      Controller.get().logout()
      window.location.reload()
    } else if( appUser) {
      Controller.get().pushToHome()
      //window.location.reload()
    } else {
      Controller.get().pushRoute({
        pathname: '/',
        search: (this.props.path && this.props.path.location && this.props.path.location.search) ? this.props.path.location.search : ''
      });
    }
  }

  render() {
    const browserHistory = this.props.path;
    return (
      <div className={css(Styles.outerMainContainer)}>
        {browserHistory.location.pathname !== '/' &&
        <div>
          <Link
            to={{ pathname: '/survey' }}
            className={css(CommonStyles.link)}>
            <div className={css(Styles.logoOuterContainer)}>
              <img
                src={require('../assets/images/mainlogo.png')}
                className={css(Styles.logoImg)}
              />
            </div>
          </Link>
        </div>
        }
        {/* {browserHistory.location.pathname !== '/survey' &&
         <Link
           to={{ pathname: '/survey' }}
           className={css(CommonStyles.link)}>
           <div className={css(Styles.outerMainContainer, Styles.outerMainContainerSecond)}>
             <Icon
               // onClick={browserHistory.goBack}
               className={css(Styles.backIcon)}>
              arrow_back
             </Icon>
           </div>
         </Link>

        } */}
        <div className={css(Styles.menuOuterContainer)}>
          {(browserHistory.location.pathname !== '/introduction' &&
          browserHistory.location.pathname !== '/profile' &&
          browserHistory.location.pathname !== '/login') ?
            <div onClick={() => this.handleClick()}>
              {this.state.drawerIsOpen ?
                <div className={css(Styles.menuInnerContainer)}>
                  <Icon
                    onClick={this.props.closeDialog}
                    className={css(Styles.expandMore)}>
                    close
                  </Icon>
                </div>
                :
                <div className={css(Styles.menuInnerContainer)}>
                  <Icon className={css(Styles.expandMore)}>dehaze</Icon>
                </div>
              }
            </div>
            :
            <div className={css(Styles.menuInnerContainer)} onClick={() => this.logOut()}>
              <Icon
                onClick={this.props.closeDialog}
                className={css(Styles.expandMore)}>
                close
              </Icon>
            </div>
          }

        </div>
        <DrawerMenu
          open={this.state.drawerIsOpen}
          onClose={this.toggleDrawer(false)}
          onOpen={this.toggleDrawer(true)}
          //items={this.state.sections}
        />
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  outerMainContainer: {
    paddingLeft: 50,
    paddingright: 50,
    display: 'flex',
    alignItems: 'flex-end',
    marginBottom: -1,
    position: 'relative',
    paddingTop: 15,
    paddingBottom: 10,
    //height: '25vh',
    '@media (max-width: 767px)': {
      // minHeight: 75,
      //padding: '0px 12px',
      //height: '15vh',
      paddingLeft: 25,
      paddingright: 25,
    },
    '@media(min-width: 768px) and (max-width: 1023px)': {
      // minHeight: 130,
      //height: '15vh',
    },
  },
  outerMainContainerSecond: {
    alignItems: 'center',
  },
  backIcon: {
    color: AppTheme.primaryColor,
    fontSize: 60,
    fontWeight: 'bolder',
    cursor: 'pointer',
    '@media (max-width: 767px)': {
      fontSize: 40,
      marginBottom: 15
    }
  },
  logoOuterContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    cursor: 'pointer',
    maxWidth: 260,
    '@media (max-width: 767px)': {
      maxWidth: 130,
    },
    '@media(min-width: 768px) and (max-width: 1023px)': {
      maxWidth: 200,
    },
  },
  logoImg: {
    maxWidth: '100%',
    '@media (max-width: 767px)': {
      maxHeight: 80
    }
  },
  menuOuterContainer: {
    display: 'flex',
    alignItems: 'center',
    position: 'fixed',
    right: 20,
    top: 20,
    justifyContent: 'center',
    zIndex: 1000000000,
    '@media (max-width: 767px)': {
      right: 12,
      top: 15,
    }
  },
  menuInnerContainer: {
    borderRadius: '50%',
    padding: 10,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  expandMore: {
    color: AppTheme.primaryColor,
    fontSize: 60,
    '@media (max-width: 767px)': {
      fontSize: 30,
    }
  },
})


// WEBPACK FOOTER //
// ./src/components/MainHeader.js